import { HelmetProvider } from 'react-helmet-async';
// import { LanguageProvider } from './Context/Language'; 
import ReactDOM from 'react-dom/client';
import React from 'react';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		{/* <LanguageProvider> */}
			<HelmetProvider>
				<App />
			</HelmetProvider>
		{/* </LanguageProvider> */}
	</React.StrictMode>
);